import { percentage } from 'sierra-client/core/format'

export const getPercentage = (value?: number): string => {
  return percentage(value)
}
